"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Adn_exports = {};
__export(Adn_exports, {
  default: () => Adn_default
});
module.exports = __toCommonJS(Adn_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.2031 8.14062L14.0938 6.05078C14.0026 5.95964 13.957 5.84896 13.957 5.71875C13.9701 5.57552 14.0221 5.45182 14.1133 5.34766C14.2174 5.25651 14.3346 5.21094 14.4648 5.21094C14.6081 5.19792 14.7253 5.24349 14.8164 5.34766L17.1016 7.63281C17.1146 7.64583 17.1276 7.65885 17.1406 7.67188C17.1536 7.6849 17.1602 7.69792 17.1602 7.71094C17.2122 7.67188 17.2643 7.63281 17.3164 7.59375C17.3685 7.54167 17.4206 7.49609 17.4727 7.45703C17.5768 7.33984 17.707 7.28125 17.8633 7.28125C18.0326 7.26823 18.1693 7.3138 18.2734 7.41797C18.3906 7.53516 18.4427 7.67188 18.4297 7.82812C18.4297 7.98438 18.3776 8.12109 18.2734 8.23828C17.7396 8.77214 17.1081 9.11719 16.3789 9.27344C15.6628 9.42969 14.9531 9.3776 14.25 9.11719L13.7812 8.94141L14.1914 10.0352C14.3086 10.3477 14.3672 10.6732 14.3672 11.0117C14.3802 11.3503 14.3346 11.6758 14.2305 11.9883C13.957 12.7826 13.4427 13.3555 12.6875 13.707C11.9453 14.0456 11.1771 14.0781 10.3828 13.8047L9.28906 13.3945L9.44531 13.8633C9.71875 14.6055 9.77083 15.3607 9.60156 16.1289C9.44531 16.8841 9.10026 17.5352 8.56641 18.082C8.44922 18.1992 8.3125 18.2643 8.15625 18.2773C8 18.2773 7.86328 18.2188 7.74609 18.1016C7.64193 17.9974 7.58984 17.8672 7.58984 17.7109C7.58984 17.5547 7.64844 17.418 7.76562 17.3008C8.14323 16.9102 8.38411 16.4479 8.48828 15.9141C8.60547 15.3672 8.56641 14.8268 8.37109 14.293L7.86328 12.8867L6.45703 12.3789C6.22266 12.2878 5.98177 12.2357 5.73438 12.2227C5.5 12.1966 5.26562 12.1966 5.03125 12.2227L6.75 13.9414C6.84115 14.0456 6.88672 14.1628 6.88672 14.293C6.88672 14.4232 6.83464 14.5404 6.73047 14.6445C6.63932 14.7487 6.52214 14.8008 6.37891 14.8008C6.2487 14.8008 6.13802 14.7552 6.04688 14.6641L3.97656 12.5938C3.88542 12.6458 3.79427 12.7044 3.70312 12.7695C3.61198 12.8346 3.52734 12.9062 3.44922 12.9844C3.33203 13.1016 3.19531 13.1602 3.03906 13.1602C2.88281 13.1602 2.7526 13.1081 2.64844 13.0039C2.53125 12.8867 2.47266 12.75 2.47266 12.5938C2.48568 12.4375 2.55078 12.3008 2.66797 12.1836C3.21484 11.6497 3.86589 11.3047 4.62109 11.1484C5.38932 10.9792 6.14453 11.0312 6.88672 11.3047L7.35547 11.4609L6.94531 10.3672C6.67188 9.57292 6.70443 8.80469 7.04297 8.0625C7.39453 7.30729 7.96745 6.79297 8.76172 6.51953C9.07422 6.41536 9.39974 6.36979 9.73828 6.38281C10.0768 6.38281 10.4023 6.44141 10.7148 6.55859L11.8086 6.96875L11.6328 6.5C11.3724 5.79688 11.3203 5.08724 11.4766 4.37109C11.6328 3.64193 11.9779 3.01042 12.5117 2.47656C12.6289 2.3724 12.7656 2.32031 12.9219 2.32031C13.0781 2.30729 13.2148 2.35938 13.332 2.47656C13.4362 2.58073 13.4818 2.71745 13.4688 2.88672C13.4688 3.04297 13.4102 3.17318 13.293 3.27734C12.9414 3.64193 12.7135 4.07161 12.6094 4.56641C12.5052 5.0612 12.5443 5.5625 12.7266 6.07031L13.2539 7.49609L14.6797 8.02344C14.9401 8.11458 15.194 8.17318 15.4414 8.19922C15.7018 8.21224 15.9557 8.19271 16.2031 8.14062ZM8.70312 7.78906C8.59896 7.86719 8.5013 7.95182 8.41016 8.04297C8.33203 8.12109 8.26042 8.21224 8.19531 8.31641L9.44531 9.58594C9.53646 9.67708 9.57552 9.79427 9.5625 9.9375C9.5625 10.0677 9.51693 10.1784 9.42578 10.2695C9.32161 10.3737 9.19792 10.4258 9.05469 10.4258C8.92448 10.4258 8.8138 10.3802 8.72266 10.2891L7.94141 9.48828C7.94141 9.56641 7.94792 9.64453 7.96094 9.72266C7.98698 9.78776 8.01302 9.85938 8.03906 9.9375L8.78125 11.9688L10.8125 12.7109C11.3073 12.8932 11.776 12.8802 12.2188 12.6719C12.6745 12.4635 12.9805 12.1315 13.1367 11.6758C13.2018 11.4805 13.2279 11.2852 13.2148 11.0898C13.2148 10.8815 13.1823 10.6732 13.1172 10.4648L12.3359 8.41406L10.2852 7.65234C10.2201 7.6263 10.1484 7.60677 10.0703 7.59375C10.0052 7.56771 9.9401 7.54818 9.875 7.53516L11.5352 9.21484C11.6393 9.30599 11.6849 9.42318 11.6719 9.56641C11.6719 9.69661 11.6198 9.80729 11.5156 9.89844C11.4245 10.0026 11.3073 10.0547 11.1641 10.0547C11.0339 10.0547 10.9232 10.0091 10.832 9.91797L8.70312 7.78906Z",
      fill: "currentColor"
    }
  )
);
const SvgAdn = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Adn_default = SvgAdn;
